import { render } from "./BottomBarTablet.vue?vue&type=template&id=ca2dc324&scoped=true"
import script from "./BottomBarTablet.vue?vue&type=script&lang=js"
export * from "./BottomBarTablet.vue?vue&type=script&lang=js"

import "./BottomBarTablet.vue?vue&type=style&index=0&id=ca2dc324&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca2dc324"]])

export default __exports__